import { supabase } from '@/integrations/supabase/client';
import Logger from '@/utils/logger';
import type { ClientCommunication, CommunicationType } from '@/types/client';
import { requireAuthUser } from './authHelpers';

const SERVICE_COMPONENT = 'clientCommunicationsService';

export async function fetchClientCommunications(clientId: string): Promise<ClientCommunication[]> {
  const { data, error } = await supabase
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    .from('client_communications' as any)
    .select('*')
    .eq('client_id', clientId)
    .order('occurred_at', { ascending: false });

  if (error) {
    Logger.error('Failed to fetch client communications', error, { component: SERVICE_COMPONENT, clientId });
    throw error;
  }
  return (data || []) as unknown as ClientCommunication[];
}

export interface CreateCommunicationParams {
  client_id: string;
  comm_type: CommunicationType;
  summary: string;
  notes?: string;
  occurred_at: string;
  contact_id?: string;
  booking_id?: string;
}

export async function createClientCommunication(
  params: CreateCommunicationParams
): Promise<ClientCommunication> {
  const ownerId = await requireAuthUser();

  const { data, error } = await supabase
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    .from('client_communications' as any)
    .insert({ ...params, owner_id: ownerId })
    .select()
    .single();

  if (error) {
    Logger.error('Failed to create client communication', error, { component: SERVICE_COMPONENT, clientId: params.client_id });
    throw error;
  }
  return data as unknown as ClientCommunication;
}

export async function deleteClientCommunication(commId: string): Promise<void> {
  const { error } = await supabase
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    .from('client_communications' as any)
    .delete()
    .eq('id', commId);

  if (error) {
    Logger.error('Failed to delete client communication', error, { component: SERVICE_COMPONENT, commId });
    throw error;
  }
}
